import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { APIService } from '../service/api.service';
import { map, catchError } from 'rxjs/operators';
import { Catalogo } from 'src/app/models/catalogo';

/**
 * class SobreResolver
 */
@Injectable({ providedIn: 'root' })
export class SobreResolver implements Resolve<[]> {
  constructor(private api: APIService) { }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> | Promise<any> {
    return this.api.getCatalogoInfo().pipe(
      map((catalogoInfo: Catalogo[]) => {
        return {
          ...catalogoInfo
        };
      }),
      catchError((error) => of({ error })),
    );
  }
}
